import { IconType } from 'react-icons';
import { FaTwitter } from 'react-icons/fa';
import { GrInstagram } from 'react-icons/gr';
import { TfiFacebook } from 'react-icons/tfi';
import { IoShareSocialSharp } from 'react-icons/io5';

const SocialIconMapping: Record<string, IconType> = {
  facebook: TfiFacebook,
  instagram: GrInstagram,
  twitter: FaTwitter,
  default: IoShareSocialSharp,
};

export default SocialIconMapping;
